import { Table } from "@pentabd/ui";

type PromotionTableProps = {
  column: any;
  rows: any;
};

export const PromotionTable = ({ column, rows }: PromotionTableProps) => {
  return <Table columns={column || []} rows={rows || []} />;
};
